var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),_c('div',{staticClass:"section"},[_c('router-view')],1),_c('Footer'),_c('Install'),_c('Contact'),_c('Log'),_c('LoginModal'),_c('LogoutModal'),_c('RegisterModal'),_c('RestoreModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }